// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x94J","top":"styles_top__2H3FK"};